import React from 'react';
import SectionContainer from '@common/components/SectionContainer';
import styled from 'styled-components';
import { token } from 'odyssey';

type AccountLayoutProps = {
  children: React.ReactNode;
};

const OuterContainer = styled.main`
  padding-bottom: ${token('space-24')};
  max-width: 100%;
  display: flex;
  justify-content: center;

  p {
    margin: ${token('space-5')} 0;
  }

  .order-summary-table {
    padding: 10px;
  }
`;

const InnerContainer = styled.div`
  width: 800px;
`;

export function AccountLayout({ children }: AccountLayoutProps) {
  return (
    <>
      <SectionContainer>
        <OuterContainer>
          <InnerContainer>{children}</InnerContainer>
        </OuterContainer>
      </SectionContainer>
    </>
  );
}
